import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Button, Loader, Text, SearchBar, Theme, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import AccountCard from '../../components/Cards/AccountCard.js';
import { getAccounts } from '../../actions/accounts.js';
import permissionLevel from '../../services/permissions.js';

class AccountList extends PureComponent {
    state = {
        query: ''
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Accounts', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        if (!this.props.accounts) {
            this.props.dispatch(getAccounts(this.state.query, 0));
        }
    }

    // submit a new search, we must reset the cursor
    _search = () => {
        this.props.dispatch(getAccounts(this.state.query, 0));
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _loadMore = () => {
        this.props.dispatch(getAccounts(this.state.query, false));
    };

    render() {
        if (!this.props.accounts) {
            return <Loader/>;
        }

        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Accounts"
                    selectedTitle="accounts"
                />

                <Content>
                    <SearchBar
                        onChange={(value) => this._handleInputChange('query', value)}
                        search={this._search}
                        placeholder="Search..."
                        iconColor={Theme.colors.skyBlue}
                        customStyle={{
                            margin: '20px auto',
                            width: '100%',
                            backgroundColor: Theme.colors.surface
                        }}
                    />

                    {
                        this.props.accounts.map((account, i) => (
                            <Link key={account.accountID} to={`/accounts/${ account.accountID }`} style={{ textDecoration: 'none' }}>
                                <AccountCard testid={i === 0 ? 'account-card' : undefined} account={account}/>
                            </Link>
                        ))
                    }

                    {
                        this.props.accounts.length === 0 &&
                        <Text
                            align="center"
                            mediumLarge
                            display="block"
                        >
                            No results to display
                        </Text>
                    }

                    {
                        this.props.cursor >= 0 &&
                        <Button
                            onClick={this._loadMore}
                            color="primary"
                            marginTop={2}
                            fullWidth
                        >
                            Load More
                        </Button>
                    }
                </Content>
                <span id="accounts" />
            </ContainerControlSite>
        );
    }
}

AccountList.propTypes = {
    accounts: PropTypes.array,
    cursor: PropTypes.number,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accounts: state.accounts.list,
    cursor: state.accounts.cursor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(AccountList);